(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["burger-drawer"] && !Shopify.designMode) return;
  try {
    // Function to move drawer bottom based on viewport height
  function repositionDrawerBottom() {
    const drawerBottom = document.querySelector('.drawer__bottom');
    const drawerLeft = document.querySelector('.drawer__left');
    const drawerInner = document.querySelector('.drawer__inner');

    // Check if all elements exist
    if (!drawerBottom || !drawerLeft || !drawerInner) {
      console.warn('Required drawer elements not found');
      return;
    }

    const viewportHeight = window.innerHeight;

    if (viewportHeight <= 520) {
      // Move to drawer__left if not already there
      if (drawerBottom.parentElement !== drawerLeft) {
        drawerLeft.appendChild(drawerBottom);
      }
    } else {
      // Move to drawer__inner if not already there
      if (drawerBottom.parentElement !== drawerInner) {
        drawerInner.appendChild(drawerBottom);
      }
    }
  }

  // Run on initial load
  repositionDrawerBottom();

  // Listen for window resize events
  window.addEventListener('resize', repositionDrawerBottom);
  } catch(e) { console.error(e); }
})();

})();
